import { render, staticRenderFns } from "./gc-popup-material-issue-info.vue?vue&type=template&id=0e6a231b"
import script from "./gc-popup-material-issue-info.vue?vue&type=script&lang=js"
export * from "./gc-popup-material-issue-info.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-material-issue-info.vue?vue&type=style&index=0&id=0e6a231b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports